import React from "react";
import { Outlet, Navigate, Link } from "react-router-dom";

//
import { Col, Row } from "react-bootstrap";

//
import Logo from "../assets/img/logo.png";

//
import Slider from "../components/auth/Slider";

const Auth = () => {
  const token = localStorage.getItem("token");

  return !token ? (
    <div className="container-fluid">
      <Row id="auth">
        <Col lg={5} xl={4} className="auth-box">
          <div className="form-box">
            <Link to="/app">
              <img src={Logo} alt="logo" className="logo" />
            </Link>
            <Outlet />
          </div>
        </Col>
        <Col
          lg={7}
          xl={8}
          className="d-none d-lg-flex align-items-center justify-content-between"
        >
          <Slider />
        </Col>
      </Row>
    </div>
  ) : (
    <Navigate to="/app" replace />
  );
};
export default Auth;
